export const PARAMETERS = 'parameters';
export const CBX003_TREATMENT_KEY = 'cbx-003';
export const CBX003_GROUP_PARAMETER_KEY = 'cardcopy';
export let CBX003_GROUP_PARAMETER_OPTIONS;

(function (CBX003_GROUP_PARAMETER_OPTIONS) {
  CBX003_GROUP_PARAMETER_OPTIONS["control"] = "control";
  CBX003_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(CBX003_GROUP_PARAMETER_OPTIONS || (CBX003_GROUP_PARAMETER_OPTIONS = {}));

export const EBX632_TREATMENT_KEY = 'ebx-632';
export const EBX632_GROUP_PARAMETER_KEY = 'group';
export let EBX632_GROUP_PARAMETER_OPTIONS; //EBX638

(function (EBX632_GROUP_PARAMETER_OPTIONS) {
  EBX632_GROUP_PARAMETER_OPTIONS["control"] = "control";
  EBX632_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(EBX632_GROUP_PARAMETER_OPTIONS || (EBX632_GROUP_PARAMETER_OPTIONS = {}));

export const EBX638_TREATMENT_KEY = 'ebx-638';
export const EBX638_GROUP_PARAMETER_KEY = 'group';
export let EBX638_GROUP_PARAMETER_OPTIONS; //EBX642

(function (EBX638_GROUP_PARAMETER_OPTIONS) {
  EBX638_GROUP_PARAMETER_OPTIONS["control"] = "control";
  EBX638_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(EBX638_GROUP_PARAMETER_OPTIONS || (EBX638_GROUP_PARAMETER_OPTIONS = {}));

export const EBX642_TREATMENT_KEY = 'ebx-642';
export const EBX642_GROUP_PARAMETER_KEY = 'group';
export let EBX642_GROUP_PARAMETER_OPTIONS;

(function (EBX642_GROUP_PARAMETER_OPTIONS) {
  EBX642_GROUP_PARAMETER_OPTIONS["control"] = "control";
  EBX642_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(EBX642_GROUP_PARAMETER_OPTIONS || (EBX642_GROUP_PARAMETER_OPTIONS = {}));